<template>
  <div class="hello3 grid h100" v-loading="loading">


  <div class="grid login">

  <!-- <transition name="slide" mode="out-in"> -->

    <!-- <div class="grid overlay" v-show="loginform"> -->

    <div class="grid logo">
      <img src="/static/img/logo-alpha.svg">
    </div>

    <div class="grid form">

    <h2 v-if="loginform && !formReset || signupform && !formReset">Accedi a Ombrelleria</h2>
    <h2 v-if="formReset">Inserisci la tua email</h2>

    <div class="spacer sm"></div>
    
      <el-form :model="formel" :rules="rules" ref="formLogin" v-if="!formReset" @keyup.enter.native="signup('formLogin')" status-icon>
        <el-form-item prop="email">
          <el-input v-model="formel.email" ref="emailinput" placeholder="Indirizzo Email" type="text" prefix-icon="fas fa-user-circle" name="email"></el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input v-model="formel.password" show-password placeholder="Password" prefix-icon="fas fa-key" name="password"></el-input>
          </el-form-item>
        <div class="spacer sm"></div>
        <el-form-item>
          <el-button class="btn btn-blue block" @click="signup('formLogin')">login</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-secondary block" v-on:click="loginform = false, signupform = true, error.state = false">registrati</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-secondary block" v-on:click="formReset = true, error.state = false">ho dimenticato la password</el-button>
        </el-form-item>
      </el-form>

      <el-form :model="formel" :rules="rules" ref="formReset" v-if="formReset" @keyup.enter.native="passreset('formReset')" status-icon>
        <el-form-item prop="email">
          <el-input v-model="formel.email" ref="emailinput" placeholder="Indirizzo Email" type="text" prefix-icon="fas fa-user-circle" name="email"></el-input>
        </el-form-item>
        <div class="spacer sm"></div>
        <el-form-item>
          <el-button class="btn btn-blue block" @click="passreset('formReset')">manda nuova password</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-secondary block" v-on:click="loginform = false, signupform = true, error.state = false">registrati</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-secondary block" v-on:click="formReset = false, error.state = false">torna alla login</el-button>
        </el-form-item>
      </el-form>

      </div> <!-- form -->

      <!-- </div> -->

      <!-- </transition> -->

  </div>

  <div class="intermed ">
    <transition name="slide-login" mode="" >
      <div class="login" :class="{ success: success.state, error : error.state }" v-show="loginform">
        <h1>Bentornato</h1>
        <p v-if="error.state">{{error.message}}</p>
        <p v-if="success.state">{{success.message}}</p>
      </div>
    </transition>
    <transition name="slide-signup" mode="" >
      <div class="signup" :class="{ success: success.state, error : error.state }" v-show="signupform">
        <h1>Benvenuto</h1>
        <p v-if="error.state">{{error.message}}</p>
        <p v-if="success.state">{{success.message}}</p>
      </div>
    </transition>
  </div>

  <div class="grid signup">

  <!-- <transition name="slide" mode="out-in"> -->

    <!-- <div class="grid overlay" v-show="signupform"> -->

    <div class="grid logo">
      <img src="/static/img/logo-alpha.svg">
    </div>

    <div class="grid form">

    <h2>Registrati a Ombrelleria</h2>

    <div class="spacer sm"></div>
    
      <el-form :model="formel" :rules="rules" ref="formsignup" v-if="" @keyup.enter.native="signup('formsignup')" status-icon>
        <el-form-item prop="email">
          <el-input v-model="formel.email" placeholder="Indirizzo Email" type="text" prefix-icon="fas fa-user-circle" name="email"></el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input v-model="formel.password" show-password placeholder="Password" prefix-icon="fas fa-key" name="password"></el-input>
          </el-form-item>
        <div class="spacer sm"></div>
        <el-form-item>
          <el-button class="btn btn-blue block" @click="signup('formsignup')">Registrati</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-secondary block" v-on:click="loginform = true, signupform = false, formReset = false, error.state = false">vai alla login</el-button>
        </el-form-item>
      </el-form>

      </div> <!-- form -->

      <!-- </div> -->

      <!-- </transition> -->

  </div>


  </div>
</template>

<script>
var host = process.env.ROOT_API
import router from './../router'
export default {
  name: 'hello',
  data () {
    return {
      forgotpassword: false,
      loginform: true,
      signupform: false,
      formReset: false,
      loading: false,
      formel: {
        email: '',
        password: ''
      },
      rules: {
        email: [
            { required: true, type: 'email', message: 'prego controlla l´ email', trigger: 'blur' }
        ],
        password: [
            { required: true, message: 'prego inserisci una password', trigger: 'blur' },
            { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }
        ]
      },
      error: {
        state: false,
        message: ''
      },
      success: {
        state: false,
        message: ''
      }
    }
  },
  methods: {
    login (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('login')
          this.loading = true
          setTimeout(() => {
            this.loading = false
          }, 2000)
          this.error.state = false
          this.$http
            .post(host + '/login', {email: this.formel.email.toLowerCase().trim(), password: this.formel.password},
            ).then((data) => {
              // this.ombrelli = data.body.ombrells
              console.log(data.body.profile)
              // localStorage.setItem('userid', data.body.id)
              localStorage.setItem('jwt', data.body.jwt)
              localStorage.setItem('profile', data.body.profile)
              // this.auth.authenticated = true
              this.loading = false
            }, (error) => {
              console.log(error)
              // this.loading = false
              setTimeout(() => {
                this.loading = false
              }, 1000)
              this.error.state = true
              this.error.message = error.body.error
            })
        } else {
          console.log('error submit!!')
          // return false
        }
      })
    },
    signup (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('login')
          this.loading = true
          this.error.state = false
          this.$http
            .post(host + '/signup', {email: this.formel.email.toLowerCase().trim(), password: this.formel.password},
            ).then((data) => {
              // this.ombrelli = data.body.ombrells
              console.log(data)
              localStorage.setItem('jwt', data.body.jwt)
              localStorage.setItem('profile', data.body.profile)
              // router.replace('Hotel')
              // this.loading = false
              this.getHotel()
            }, (error) => {
              console.log(error)
              this.loading = false
              this.error.state = true
              this.error.message = error.body.error
            })
        } else {
          console.log('error submit!!')
          // return false
        }
      })
    },
    passreset (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('passreset')
          this.loading = true
          this.error.state = false
          this.$http
            .post(host + '/forgot', {email: this.formel.email.toLowerCase().trim()},
            ).then((data) => {
              // this.ombrelli = data.body.ombrells
              console.log(data)
              this.loading = false
              this.success.state = true
              this.success.message = data.body.success
              // localStorage.setItem('jwt', data.body.jwt)
              // localStorage.setItem('profile', data.body.profile)
              // router.replace('Hotel')
              // this.loading = false
              // this.getHotel()
            }, (error) => {
              console.log(error)
              this.loading = false
              this.error.state = true
              this.error.message = error.body.error
            })
        } else {
          console.log('error submit!!')
          // return false
        }
      })
    },
    getHotel () {
      this.$http
        .get(host + '/ombrelloni',
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.jwt
          }
        },
        ).then((data) => {
          console.log(data)
          this.loading = false
          if (data.body.hotels.length > 1) {
            console.log('multihotel')
            router.replace('hotel')
          } else if ((data.body.hotels.length === 1)) {
            console.log('one hotel')
            router.replace('ombrelli/' + data.body.hotels[0]._id)
          } else {
            console.log('no hotel')
            router.replace('addhotel')
          }
        }, (error) => {
          console.log(error)
          this.loading = false
          this.error.state = true
          this.error.message = error.body.error
        })
    },
    getSettings () {
      console.log(location.hash)
      if (location.hash === '#signup') {
        this.loginform = false
        this.signupform = true
      }
    }
  },
  beforeMount () {
    this.getSettings()
  },
  mounted: function () {
    // this.$refs.emailinput.focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 1;
}*/

.slide-login-enter-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  /*opacity: 1;*/
  h1 {
    opacity: 0;
  }
}
.slide-login-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transform: translateX(-100%);
}
.slide-login-enter, .slide-leave-to {
  transform: translateX(-100%);
  /*opacity: 0;*/
}


.slide-signup-enter-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  /*opacity: 1;*/
  h1 {
    opacity: 0;
  }
}
.slide-signup-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transform: translateX(100%);
}
.slide-signup-enter, .slide-leave-to {
  transform: translateX(100%);
  /*opacity: 0;*/
}

/*.slide-fade-enter-active {
  transition: all .6s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(-50%);
  opacity: 1;
}
.slide-fade-login-enter-active {
  transition: all .6s ease;
}
.slide-fade-login-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-login-enter, .slide-fade-login-leave-to {
  transform: translateX(-50%);
  opacity: 1;
}
.slide-fade-login-enter, .slide-fade-login-leave-to {
  transform: translateX(50%);
  opacity: 1;
}*/
</style>



// WEBPACK FOOTER //
// Hello.vue?48b58249